import React from 'react';
import Dropdown from '@techsoftware/happay-widgets/Dropdown';
import TextInput from '@techsoftware/happay-widgets/TextInput';
import Grid from '@techsoftware/happay-widgets/Grid';
import Button from '@techsoftware/happay-widgets/Button';
import { isMobile } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
// import InvoiceDetail from '../../DetailView';
export default function EditVendorDetails({
  vendor,
  handleChange,
  vendorList = [],
  drawCardUI,
  history,
  error: { vendorError },
  isEditInvoice,
  isGstinFlow,
  ocrImg,
  ocrScan,
  shimmer,
}) {
  const { is_gstin_flow = false } = vendor || {};
  const vendorCardContent = (
    <Grid
      container
      className={`padding-lr-${isMobile ? '20' : '100'} padding-b-30`}
    >
      <Grid item className="d-flex" alignItems="baseline">
        <Grid item xs={13} sm={13} md={13} lg={13} xl={13}>
          <Dropdown
            id="select-vendor-name-dropdown"
            labelText="Registered Name"
            isRequired
            value={vendor || ''}
            onChange={(e, i, dt) =>
              handleChange('vendor', Object.keys(dt).length > 1 ? dt : '')
            }
            data={vendorList}
            autoFocus
            valueType="object"
            disabled={vendorList.length === 0}
            dropdownInputHintText="Type Vendor name"
            customDropdownStyle={{ marginBottom: '30px' }}
            dataConfig={{ text: 'vendor_name', value: 'vendor_id' }}
            errorText={!vendorList.length ? 'No vendor list' : vendorError}
            errorType={vendorError && 'error'}
            showDropdownSearchBar={vendorList.length > 5}
            extraIconImg={ocrScan.vendor && vendor ? ocrImg : ''}
            extraIcon
            extraIconTooltipPlacement="hw-bottom-left"
            extraIconTooltip={ocrScan.vendor && vendor && 'Auto-fetched via ScanX'}
            shimmer={vendor ? false : shimmer}
          />
        </Grid>
        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="align-center">
          OR
        </Grid>
        <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
          <Button
            type="button"
            text="New Vendor"
            variant="secondary"
            className="vendor-fetch-btn"
            size="large"
            startIcon="add"
            buttonParentStyles={{ padding: '10px 0px', width: '100%' }}
            onClick={() =>
              history.push({
                pathname: '/vendor/myvendor/createView',
                state: { from: 'invoice' },
              })
            }
          />
        </Grid>
      </Grid>
      <TextInput
        floatingLabelText="Vendor Display Name"
        required
        value={vendor?.display_name || ''}
        type="text"
        disabled
        clearMargin
        customInputParentStyle={{ marginBottom: '30px' }}
        // onChange={(e, val) => handleChange('displayName', val)}
      />
      <TextInput
        floatingLabelText={
          isEditInvoice
            ? isGstinFlow
              ? 'GSTIN'
              : 'PAN'
            : is_gstin_flow
            ? 'GSTIN'
            : 'PAN'
        }
        required
        value={vendor?.identification_id || ''}
        type="text"
        disabled
        clearMargin
        // onChange={(e, val) => handleChange('vendorGSTIN', val)}
      />
    </Grid>
  );
  return drawCardUI('Vendor Details', 1, vendorCardContent);
}

